export * from "./financial";
export * from "./fixedCosts";
export * from "./objectives";
export * from "./timesheets";

const defaultMoneyOptions = {
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
};

export const formatMoney = (value, options = defaultMoneyOptions) => {
  if (value === null || value === undefined || value === "") {
    return "—";
  }

  const numericValue = Number(value);
  if (!Number.isFinite(numericValue)) {
    return "—";
  }

  return new Intl.NumberFormat("fr-FR", {
    style: "currency",
    currency: "EUR",
    ...defaultMoneyOptions,
    ...options,
  }).format(numericValue);
};
